import { IconStyled, IconStylesProps } from './IconStyles';

export const Clone = ({ size = 'base', className = '', fill = 'currentColor' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 11 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <path d="M7.85714 11.241V12.2447C7.85714 12.5773 7.59331 12.8469 7.26786 12.8469H0.589286C0.263828 12.8469 0 12.5773 0 12.2447V3.01099C0 2.67841 0.263828 2.4088 0.589286 2.4088H2.35714V9.83592C2.35714 10.6107 2.97395 11.241 3.73214 11.241H7.85714ZM7.85714 2.60953V0H3.73214C3.40669 0 3.14286 0.269609 3.14286 0.602199V9.83592C3.14286 10.1685 3.40669 10.4381 3.73214 10.4381H10.4107C10.7362 10.4381 11 10.1685 11 9.83592V3.21173H8.44643C8.12232 3.21173 7.85714 2.94074 7.85714 2.60953ZM10.8274 1.83096L9.2083 0.176369C9.09779 0.0634423 8.94791 8.35039e-07 8.79163 0L8.64286 0V2.4088H11V2.25677C11 2.09706 10.9379 1.94389 10.8274 1.83096Z" fill={fill} />
   </IconStyled>
);
